import React from "react";

import { SmartHomeLogo, TuyaLogo } from "@/components/icons/workspaces";
import { IntermediatePage } from "@/components/organisms/IntermediatePage";

// Define the smart home navigation structure
const smartHomeNavNode = {
  children: [
    {
      icon: SmartHomeLogo,
      id: "switchbot",
      link: "/smarthome/switchbot",
      title: "SwitchBot",
    },
    {
      icon: TuyaLogo as React.ComponentType<React.SVGProps<SVGSVGElement>>,
      id: "tuya",
      link: "/smarthome/tuya",
      title: "Tuya",
    },
    // Future integrations can be added here
    // {
    //   id: 'philips-hue',
    //   title: 'Philips Hue',
    //   link: '/smarthome/philips-hue',
    //   icon: SmartHomeLogo,
    // }
  ],
  id: "smarthome",
  title: "Smart Home",
};

export const SmartHomeAppWithCards: React.FC = () => {
  return (
    <IntermediatePage
      description="Verwalte deine Smart Home Integrationen und Geräte"
      headerGradient={{ from: "from-blue-500", to: "to-blue-600" }}
      icon={<SmartHomeLogo size="app" />}
      navNode={smartHomeNavNode}
      title="Smart Home"
    />
  );
};
